export default __webpack_public_path__ + "static/audio-cardio-3-bb-3998a6abaf1efe63db5fe724e9eb1675.webp";